import { createAction, props } from '@ngrx/store';
import { ObterArquivoCadernoIdInputDto } from 'src/app/domain/DTOs/input/jornal/obter-arquivo-caderno-id.input.dto';
import { EstruturaRetornoDadosOutputDto } from 'src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto';
import { ArquivoCadernoOutputDto } from 'src/app/domain/DTOs/output/jornal/arquivo-caderno.output.dto';

const actionName = "[ ObterArquivoCadernoPorId ] Obter Arquivo Caderno Por Id";

export const obterArquivoCadernoPorId = createAction(
  actionName,
  props<{ inputDto: ObterArquivoCadernoIdInputDto}>()
);

export const obterArquivoCadernoPorIdSuccess = createAction(
  `${actionName} - Sucesso`,
  props<{ response: EstruturaRetornoDadosOutputDto<ArquivoCadernoOutputDto> }>()
);

export const obterArquivoCadernoPorIdFailure = createAction(
  `${actionName} - Falha`,
  props<{ response: EstruturaRetornoDadosOutputDto<ArquivoCadernoOutputDto> }>()
);

export const obterArquivoCadernoPorIdFinish = createAction(
  `${actionName} - Concluir`
);
